import React, { useCallback, useState } from "react";
import useTableElements from "data-lake/hooks/useTableElements";
import { DEFAULT_LAYOUT, ADDITIONAL_ATTRIBUTES } from "data-lake/data-lake-overview/Constants";
import { keyFn, fetchDataLakes } from "data-lake/hooks/useDataLakes";
import { PaginatedEntityTable } from "components/common";
import SelectedInternalDataLakeProvider from "data-lake/contexts/SelectedInternalDataLakeProvider";
import customColumnRenderers from "./ColumnRenderers";
import DeletedStreamsWarning from "./DeletedStreamsWarning";
const DataLakeOverview = () => {
  const { entityActions } = useTableElements();
  const [showDeletedStreamsWarning, setShowDeletedStreamsWarning] = useState(false);
  const onDataLoaded = useCallback((data) => {
    setShowDeletedStreamsWarning(data.list.some((dataLake) => dataLake.stream_title === null));
  }, []);
  return /* @__PURE__ */ React.createElement(SelectedInternalDataLakeProvider, null, showDeletedStreamsWarning && /* @__PURE__ */ React.createElement(DeletedStreamsWarning, null), /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "data lakes",
      additionalAttributes: ADDITIONAL_ATTRIBUTES,
      entityActions,
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchDataLakes,
      keyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers: customColumnRenderers,
      onDataLoaded
    }
  ));
};
export default DataLakeOverview;
